module.exports = __webpack_public_path__ + "static/finish-a3b1b1cffe38f7706e4ce7fb7b9ac7c2.svg";